import api from './api';

export const getFunnelixContatti = async (params = {}) => {
  const response = await api.get('/funnelix/contatti', { params });
  return response.data;
};

export const getFunnelixContattiDistincts = async (params = {}) => {
  const response = await api.get('/funnelix/contatti/distincts', { params });
  return response.data;
};

export const getFunnelixContattiPipelineSummary = async (params = {}) => {
  const response = await api.get('/funnelix/contatti/pipeline-summary', { params });
  return response.data;
};

export const getFunnelixContattiStageSummary = async (params = {}) => {
  const response = await api.get('/funnelix/contatti/stage-summary', { params });
  return response.data;
};

export const importFunnelixContatti = async (payload = {}) => {
  const response = await api.post('/funnelix/import/contatti', payload);
  return response.data;
};

export const startImportFunnelixContattiJob = async (payload = {}) => {
  const response = await api.post('/funnelix/import/contatti/job', payload);
  return response.data;
};

export const getImportFunnelixContattiJobStatus = async (jobId) => {
  const response = await api.get(`/funnelix/import/contatti/job/${jobId}`);
  return response.data;
};

export const getLastSuccessfulImportFunnelixContatti = async () => {
  const response = await api.get('/funnelix/import/contatti/last-successful');
  return response.data;
};

export const getEstimateImportFunnelixContatti = async (params = {}) => {
  const response = await api.get('/funnelix/import/contatti/estimate', { params });
  return response.data;
};

export const verificaFunnelixClienti = async (payload = {}) => {
  const response = await api.post('/funnelix/verifica-clienti', payload);
  return response.data;
};

export const startVerificaFunnelixClientiJob = async (payload = {}) => {
  const response = await api.post('/funnelix/verifica-clienti/job', payload);
  return response.data;
};

export const startPushClientiFunnelixJob = async (payload = {}) => {
  const response = await api.post('/funnelix/clienti/push/job', payload);
  return response.data;
};

export const getPushClientiFunnelixJobStatus = async (jobId) => {
  const response = await api.get(`/funnelix/clienti/push/job/${jobId}`);
  return response.data;
};

export const refreshFunnelixPipeline = async () => {
  const response = await api.post('/funnelix/cache/pipeline/refresh');
  return response.data;
};

export const getFunnelixLogSync = async (params = {}) => {
  const response = await api.get('/funnelix/log-sync', { params });
  return response.data;
};

export const getFunnelixPipeline = async () => {
  const response = await api.get('/funnelix/pipeline');
  return response.data;
};

export const getFunnelixStage = async (params = {}) => {
  const response = await api.get('/funnelix/stage', { params });
  return response.data;
};

export const getFunnelixKpi = async (params = {}) => {
  const response = await api.get('/funnelix/kpi', { params });
  return response.data;
};
